<template>
  <div class="panel-container">
    <IntegrationConfigCard
      v-bind="$props"
    />
    <HubSpotForm
      class="successfactors-panel"
      form-id="a4f80667-9d1e-4485-870c-fe9258412bc0"
    />
  </div>
</template>

<script>
import HubSpotForm from '@/components/settings/integrations/HubSpotForm.vue';
import IntegrationConfigCard from '@/components/settings/integrations/IntegrationConfigCard.vue';

export default {
  name: 'SuccessFactors',
  components: {
    HubSpotForm,
    IntegrationConfigCard,
  },
  props: {
    atsName: { type: String, default: '' },
    guidance: { type: String, default: '' },
    logoUrl: { type: String, default: '' },
  },
};
</script>

<style scoped lang="less">
  .successfactors-panel {
    width: calc(50% - 6px);
  }
</style>
